import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from "@angular/core";
import { SvgHelper } from "@app/shared";

@Component({
  selector: "[shadow-type-4]",
  templateUrl: "./shadow-type-4.component.html",
  styleUrl: "./shadow-type-4.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ShadowType4Component {
  height = input<number>();

  shadowPoints = [182, 331, 91, 326, 175, 161, 268, 208, 324, 240];
  multiplier = 0.4;

  shadowPath = computed(() => {
    const delta = SvgHelper.calculateDelta(this.height(), this.multiplier);
    return SvgHelper.generateType1ShadowPath(delta, this.shadowPoints);
  });
}
